<template>
	<div class="information-details-page">
		<Head mode="black" :isHaveBack="true" @back="backHead"></Head>
		<div class="main w1200">
			<div class="left-section">
				<div class="bread-bar" v-if="from">
					<div class="item c-pointer" v-if="from == 1" @click="backBread">首页&nbsp;&gt;&nbsp;</div>
					<div class="item c-pointer" v-else-if="from == 2" @click="backBread">资讯&nbsp;&gt;&nbsp;</div>
					<div class="item c-primary">资讯详情</div>
				</div>
				<div class="article" v-if="details">
					<div class="title">{{ details.title }}</div>
					<div class="fields">
						<div class="fields-item">来源：{{ details.source }}</div>
						<div class="fields-item">发布时间：{{ $moment(details.releaseTime).format('YYYY年MM月DD日') }}</div>
					</div>
					<div class="rich-txt" :key="id" v-rem v-html="formatRichText(details.content)"></div>
					<div class="btns">
						<div class="prev ellipsis-1" :title="details.prev && details.prev.title" @click="prevArticle">上一篇：{{details.prev ? details.prev.title : '已经是第一篇了'}}</div>
						<div class="list" @click="back">返回</div>
						<div class="next ellipsis-1" :title="details.next && details.next.title" @click="nextArticle">下一篇：{{details.next ? details.next.title : '已经是最后一篇了'}}</div>
					</div>
				</div>
			</div>
			<div class="right-section">
				<div class="heading">推荐资讯</div>
				<div class="list" v-if="recommendList && recommendList.length">
					<router-link tag="div" :to="{ name: $route.name, query: { id: item.id, type: type, from: from} }" v-for="(item, index) in recommendList" :key="item.id">
						<div class="list-item">
							<div class="header">
								<div class="tag" v-if="type">
									<template v-if="type == 1">政策文件</template>
									<template v-if="type == 2">通知公告</template>
								</div>
								<!-- <div class="date">{{ $moment(item.createTime).format('YYYY-MM-DD') }}</div> -->
							</div>
							<div class="title ellipsis-2">{{ item.title }}</div>
							<svg-icon name="arrow4"></svg-icon>
						</div>
					</router-link>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
import { RecommendPolicy, PolicyDetails, InformationDetails, RecommendInformation } from '@/common/api.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
export default {
	name: 'informationDetails',
	components: {
		Head,
		Foot,
	},
	props: {
		id: {
			type: [String, Number],
			default: ''
		},
		type: {
			type: [String, Number],
			default: ''
		},
		// 1 首页 2 资讯
		from: {
			type: [String, Number],
			default: ''
		},
	},
	data() {
		return {
			// 详情
			details: null,
			// 推荐列表
			recommendList: [],
		};
	},
	watch: {
		id: {
			handler: function (val) {
				this.getDetails()
				this.getRecommend();
			}
		}
	},
	created() {
		this.getDetails()
		this.getRecommend();
	},
	methods: {
		backHead() {
			this.$router.go(-1);
		},
		backBread() {
			if (this.from == 1) {
				this.$router.push({name: 'home'})
			} else if (this.from == 2) {
				this.$router.push({name: 'information'})
			}
		},
		back() {
			this.$router.go(-1);
		},
		prevArticle() {
			if (this.details.prev) {
				this.$router.push({name: this.$route.name, query: { id: this.details.prev.id, type: this.type, from: this.from} })
			}
		},
		nextArticle() {
			if (this.details.next) {
				this.$router.push({name: this.$route.name, query: { id: this.details.next.id, type: this.type, from: this.from} })
			}
		},
		getDetails() {
			if (this.type == 1) {
				this.getPolicyDetails()
			} else if (this.type == 2) {
				this.getInformationDetails();
			}
		},
		//获取资讯详情
		getInformationDetails() {
			let data = {
				id: this.id
			};
			InformationDetails(data).then((res) => {
				this.details = res.data;
			});
		},
		//获取政策详情
		getPolicyDetails() {
			let data = {
				id: this.id
			};
			PolicyDetails(data).then((res) => {
				this.details = res.data;
			});
		},
		getRecommend() {
			if (this.type == 1) {
				this.getRecommendPolicy()
			} else if (this.type == 2) {
				this.getRecommendInformation();
			}
		},
		//获取资讯推荐列表
		getRecommendInformation() {
			let data = {
				id: this.id
			};
			RecommendInformation(data).then((res) => {
				this.recommendList = res.data;
			});
		},
		//获取政策推荐列表
		getRecommendPolicy() {
			let data = {
				id: this.id
			};
			RecommendPolicy(data).then((res) => {
				this.recommendList = res.data;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.information-details-page {
	background: #ebeff8;
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	.main {
		margin-top: 12px;
		margin-bottom: 12px;
		display: flex;
		justify-content: space-between;
		padding: 0 20px 0 30px;
		background: #ffffff;
		flex: 1;
		.left-section {
			width: 740px;
			margin-right: 37px;
			display: flex;
			flex-direction: column;
			.bread-bar {
				padding: 20px 0;
				display: flex;
				.item {
					font-size: 14px;
					color: #333333;
					line-height: 20px;
				}
			}
			.article {
				flex: 1;
				display: flex;
				flex-direction: column;
				padding: 10px 0;
				.title {
					font-weight: bold;
					font-size: 30px;
					color: #000000;
					line-height: 42px;
					text-align: justify;
				}
				.fields {
					margin-top: 20px;
					padding-bottom: 36px;
					border-bottom: 1px solid #f1f1f1;
					display: flex;
					flex-wrap: wrap;
					.fields-item {
						margin-right: 40px;
						font-size: 12px;
						color: #9f9f9f;
						line-height: 17px;
					}
				}
				.rich-txt {
					padding: 10px 0;
					font-size: 16px;
					line-height: 34px;
				}
				.btns {
					margin-top: auto;
					padding: 40px 0;
					display: flex;
					.next,
					.list,
					.prev {
						width: 228px;
						height: 34px;
						border: 1px solid #999999;
						padding: 0 16px;
						box-sizing: border-box;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #666666;
						line-height: 32px;
						text-align: center;
						cursor: pointer;
						&:hover {
							border-color: $primary;
							background-color: $primary;
							color: #FFFFFF;
						}
						&:active {
							background-color: $primary-dark;
						}
					}
					.list {
						margin: 0 18px;
					}
				}
			}
		}
		.right-section {
			flex: 1;
			display: flex;
			flex-direction: column;
			.heading {
				margin-top: 37px;
				font-weight: bold;
				font-size: 20px;
				color: #000000;
				line-height: 28px;
				margin-bottom: 20px;
			}
			.list {
				flex: 1;
				display: flex;
				flex-direction: column;
				.list-item {
					margin-bottom: 10px;
					display: flex;
					flex-direction: column;
					cursor: pointer;
					height: 186px;
					background: #FFFFFF;
					border: 1px solid #E7E7E7;
					padding-top: 27px;
					padding-left: 18px;
					padding-right: 14px;
					// padding-bottom: 27px;
					box-sizing: border-box;
					transition: all 0.5s ease;
					&:hover {
						padding-top: 17px;
						box-shadow: 0px 6px 11px 0px rgba(0,0,0,0.1);
						border: 1px solid #29965C;
						// .title {
						// 	margin-top: 22px;
						// }
						.svg-arrow4 {
							display: block;
						}
					}
					.header {
						display: flex;
						align-items: center;
						.tag {
							padding: 0 7px;
							height: 25px;
							background: #29965C;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 14px;
							color: #FFFFFF;
							line-height: 25px;
						}
						.date {
							margin-left: auto;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 12px;
							color: #9F9F9F;
							line-height: 22px;
						}
					}
					.title {
						transition: all 0.5s ease;
						margin-top: 32px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 18px;
						color: #000000;
						line-height: 25px;
					}
					.svg-arrow4 {
						transition: all 0.5s ease;
						display: none;
						margin-top: 15px;
						width: 25px;
						height: 25px;
					}
				}
			}
		}
	}
}
</style>
